import { red } from "@mui/material/colors";
import { components } from "./components";

const themeOptions = {
  typography: {
    fontSize: 14,
    // Use the CSS variables declared in src/index.css so both plain CSS and MUI share the same font stack
    fontFamily: "var(--font-family-sans)",
    // Provide heading overrides to use the (serif) heading font for a professional tone
    h1: { fontFamily: "var(--font-family-heading)", fontWeight: 700 },
    h2: { fontFamily: "var(--font-family-heading)", fontWeight: 700 },
    h3: { fontFamily: "var(--font-family-heading)", fontWeight: 600 },
    h4: { fontFamily: "var(--font-family-heading)", fontWeight: 600 },
    h5: { fontFamily: "var(--font-family-heading)", fontWeight: 600 },
    h6: { fontFamily: "var(--font-family-heading)", fontWeight: 600 },
    body1: { fontSize: "14px" },
  },

  status: { danger: red[500] },
  components: { ...components },
};

export default themeOptions;
